module.exports = __webpack_public_path__ + "img/xqgl4.9c593cce.png";